export const GiftPicker = ({ gifts, onSend }) => (
  <div data-testid="gift-picker" className="glass rounded-2xl p-3 grid grid-cols-3 gap-2">
    {gifts.map((g) => (
      <button key={g.id} data-testid={`gift-${g.id}`} onClick={() => onSend(g.id)} className="card rounded-xl p-3 text-center hover:scale-105 transition-transform">
        <div className="text-3xl">{g.emoji}</div>
        <p className="text-xs font-semibold mt-1">{g.name}</p>
        <p className="font-num text-[11px] font-bold text-[var(--accent-c)]">₹{g.cost / 6}</p>
      </button>
    ))}
  </div>
);
